import React, { useState, useEffect } from "react";
import Draggable from "react-draggable";
import { Resizable } from "react-resizable";
import { Box } from "@mui/material";
import { Maximize2 } from "lucide-react";
import { useLayoutContext } from "../../contexts/LayoutContext";

// Normalize videoWindowSize from context (can be [w,h] or { width, height })
const getSize = (videoWindowSize) => {
  if (!videoWindowSize) return { width: 400, height: 400 };
  if (typeof videoWindowSize.width === "number" && typeof videoWindowSize.height === "number") {
    return { width: videoWindowSize.width, height: videoWindowSize.height };
  }
  const [w, h] = Array.isArray(videoWindowSize) ? videoWindowSize : [400, 400];
  return { width: w ?? 400, height: h ?? 400 };
};

function ScreenshotRegionSelector({ openScreenshotSelector, onSelect }) {
  const [{ videoWindowSize }] = useLayoutContext();
  const { width: winW, height: winH } = getSize(videoWindowSize);

  const [state, setState] = useState({ width: 240, height: 150 });
  const [position, setPosition] = useState({ x: winW / 2 - 80, y: winH / 2 - 50 });

  const onStart = (e, data) => {};

  const onStop = (e, data) => {
    const { x, y } = data;
    setPosition({ x, y });
    onSelect({ width: state.width, height: state.height, x, y });
  };

  useEffect(() => {
    if (openScreenshotSelector) {
      setState({ width: 240, height: 150 });
      setPosition({ x: winW / 2 - 80, y: winH / 2 - 50 });
      onSelect({ width: 240, height: 150, x: winW / 2 - 80, y: winH / 2 - 50 });
    }
  }, [openScreenshotSelector]); // eslint-disable-line react-hooks/exhaustive-deps

  // Only recenter when window dimensions actually change (primitives avoid update loop from new object refs)
  useEffect(() => {
    setPosition({ x: winW / 2 - 80, y: winH / 2 - 50 });
  }, [winW, winH]);

  return (
    <Box
      sx={{
        pointerEvents: "none",
        width: "100%",
        height: "100%",
        // margin-top: 111px;
        background: "transparent",
      }}
    >
      <Draggable
        bounds="parent"
        handle=".wrapper"
        axis="both"
        onStart={onStart}
        onStop={onStop}
        position={position}
        defaultPosition={{ x: 100, y: 100 }}
      >
        <div className="box">
          <Resizable
            className="resizable-container"
            height={state.height}
            width={state.width}
            onResize={(e, { element, size, handle }) => {
              const next = { width: size.width, height: size.height };
              setState(next);
              onSelect({ ...next, x: position.x, y: position.y });
            }}
            axis="both"
            minConstraints={[100, 100]}
            maxConstraints={[winW - position.x, winH - position.y]}
            handle={
              <div className="draghandle">
                <Maximize2 style={{ transform: "rotate(90deg)" }} color={"#ffffff"} />
              </div>
            }
          >
            <div className="box" style={{ width: state.width + "px", height: state.height + "px", border: 'red dashed 1px' }}>
              <div className="wrapper" style={{ width: "100%", height: "100%" }}></div>
            </div>
          </Resizable>
        </div>
      </Draggable>
    </Box>
  );
}

export default ScreenshotRegionSelector;
